module.exports = __webpack_public_path__ + "img/140.3e3f5f1f.jpg";